import React from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { isRsvpEnabled } from "../features";

export default function Header() {
  const { authenticated, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isWideAdminPage = ["/admin/guests", "/admin/expenses"].includes(
    location.pathname
  );

  return (
    <header className={`site-header${isWideAdminPage ? " wide-admin-header" : ""}`}>
      <Link to="/" className="wordmark">
        Ryan &amp; Lily
      </Link>
      <nav className="site-nav">
        <NavLink to="/" end>
          Home
        </NavLink>
        <NavLink to="/travels">Our Story</NavLink>
          {isRsvpEnabled() && <NavLink to="/rsvp">RSVP</NavLink>}
        <NavLink to="/timeline">Timeline</NavLink>
        <NavLink to="/faq">FAQ</NavLink>
        {authenticated ? (
          <>
            <NavLink to="/admin/expenses">Expenses</NavLink>
            <NavLink to="/admin/guests">Guests</NavLink>
            <NavLink to="/admin/settings">Settings</NavLink>
            <button
              className="link-button"
              onClick={async () => {
                await logout();
                navigate("/");
              }}
            >
              Sign Out
            </button>
          </>
        ) : (
          <NavLink to="/login">Sign in</NavLink>
        )}
      </nav>
    </header>
  );
}
